import { auth, envelopes } from '@verified/libvf';
import log from './log';
import axios from 'axios';
const verified = {

    fakeSubmit: false,
    useTestInc: false,
    logTag: 'flow: ',
    personalToken: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsidWlkIjoiL3VzZXJzL0JKLVFOVXo2QiIsImZhbWlseU5hbWUiOiJVcnNpbiIsImdpdmVuTmFtZSI6Ik1hZ251cyIsImVtYWlsIjoibWFnbnVzLnVyc2luQHZlcmlmaWVkLmV1IiwibmFtZXNwYWNlIjoiIn0sImp0aSI6IkJKLVFOVXo2Qi1xZHo4cHMiLCJpYXQiOjE1OTQ5OTUwNDAsImF1ZCI6Imk6ODguOTUuMjIuNyIsImV4cCI6MTU5NTU5OTg0MH0.QCjufNGedZrX5WADVYFAxuTNjhk7soO08xEXBNOi9ngQvXjOKUpyIBC4EWw83GN2AS0aXxYKAlZEHEPYX37rpEAw_uhx752hJkdSxi5ORJJNwB5QZkZZG64GbMwFsmXc1PFJRZrUalmVJQZ-GcFR9DTs3dsnCZEPR1QM4_bqdJnNnB5hCHkvdUO9KHspzIySV61-7gXYlCE6gLmHtcSEBuSB1EofhTnspz0zY4RWd0ei4mciWYJclzWcw_PSOZVme9t3uAfrAWOzq-A4bbAuLpUw8vbibHH8l70UGXdb8dLFuPCEgIf8oPducltvo3LEkV336XO7nb9ZUA27rQ_sdg',
    silentPublicToken: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsidWlkIjoiL3B1YmxpYy9jb21wYW5pZXMvcjFNWnRmV1c3L3RtcGwvbWF4Ym8tZnJha3RhdnRhbGUtc2lsZW50IiwiZmFtaWx5TmFtZSI6IlByb2ZmIiwiZ2l2ZW5OYW1lIjoiTWF4Ym8iLCJuYW1lc3BhY2UiOiIvY29tcGFuaWVzL3IxTVp0ZldXNyJ9LCJqdGkiOiJxZG80bDMtcmY3ejkzIiwiaWF0IjoxNTk1MDgxMjcxLCJyb2xlcyI6WyIvcm9sZXMvdG1wbC9jb21wYW5pZXMvcjFNWnRmV1c3Il0sInBlcm1zIjpbXSwiZXhwIjoxNjU4MTUzMjcxfQ.RAMR78pC09CxZAcEKJXfbc0XQjOyHdQjyR9fw17OvwFtOAb6OMKT1GCYqr6g22SqSLkOvkompbnN9MAMOx_XF_ZC_5G1eiQTsYXz-sDS-3D2x0Cecy2el6zuXx1q89LbmI1BJxaM6xowM-pKIHmiYhzneb66A6U-sg8X6szthWqEeZCisfBD9Gssd5RuGpwTTPbunWNHBMpME19_o9LqH-2gPWCVK0cjlcmzA9XI7ywTyJtHjmyKA7Pi-LW8u-zMZsShhwHlYqtgop4_uUzisp4TKhWTAzbNGNa3DrwpIuhf3HrqCHQZQfeofRqKS4QOEanm_yMDTK4KlGpGOGHgig',

    async setToken(approve) {
        if (approve) {

        }
    },

    async authenticatePublic(approve) {
        let companyId = 'Hk7_2sKO-';
        let approveToken = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsidWlkIjoiL3B1YmxpYy9jb21wYW5pZXMvSGs3XzJzS08tL3RtcGwvbWF4Ym8tZnJha3RhdnRhbGUtYXBwcm92ZSIsImZhbWlseU5hbWUiOiJQcm9mZiIsImdpdmVuTmFtZSI6Ik1heGJvIiwibmFtZXNwYWNlIjoiL2NvbXBhbmllcy9IazdfMnNLTy0ifSwianRpIjoidGhnMHY3LXhubmZqNyIsImlhdCI6MTc4MjgyMDE5NSwicm9sZXMiOlsiL3JvbGVzL3RtcGwvY29tcGFuaWVzL0hrN18yc0tPLSJdLCJwZXJtcyI6W10sImV4cCI6MjAzNTEwODE5NX0.mFhYvtWezf33SzEKsevG2YyyejIdAdPzd9BMzZjIkL1NmttvXLaF2hA7A4ENLw1ubiZ7W-EpAVKa3sOZeZd0ri29y0GTORBUBHCd31Ee6aRJ9nV6ZiJTQuWPebj10HCxPJE4lAWJ6XXrHdUhkFFCLg4uDlHL7F1R-TnmGv83ttZr_KBJ3-vG9_rCJTULDkOr1HYRuIVAIFmUYFbcr6YvfDc8Vv5g7HmZOdy-yUBXmHZi2K18UwHVmOCn_ixKybGWs8lAsM1TfYwEtOFFcIfu0g9lqPKnkc5GYKsG7wU6-cAMY7MoT9f59vH9CNbwIbzacB3ed2Q3kScL3ANcQhM5nQ';
        let silentToken = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOnsidWlkIjoiL3B1YmxpYy9jb21wYW5pZXMvSGs3XzJzS08tL3RtcGwvbWF4Ym8tZnJha3RhdnRhbGUtc2lsZW50IiwiZmFtaWx5TmFtZSI6IlByb2ZmIiwiZ2l2ZW5OYW1lIjoiTWF4Ym8iLCJuYW1lc3BhY2UiOiIvY29tcGFuaWVzL0hrN18yc0tPLSJ9LCJqdGkiOiJ0aGcweTYteG5uZm02IiwiaWF0IjoxNzgyODIwMzAyLCJyb2xlcyI6WyIvcm9sZXMvdG1wbC9jb21wYW5pZXMvSGs3XzJzS08tIl0sInBlcm1zIjpbXSwiZXhwIjoyMDM1MTA4MzAyfQ.mhtcoXa93vPPjWZMUiRf2v7kV7bN8DIA0gjPY7gtlgibjO4lGsclXHZo7IbjaND7fLF8Q1cncUwY_vXAquo7Qx5U8vo9udhS7gXTYz1olk7NVRfIXNn0N6NGAXWME30NsjaaAwzQMmQZAyAeyPQoyczx01jjSwxRQA-ci6itI2g9fyM6F_2mUpWS06TfSyHOa6C9gv5ZgLaOO2fCEpXhRP-m8tyZYq4XjfclVauECnnNHbPxR-kfhsxwpXnw6M6AIQ9OocSCBWBMHb1H_MxiLhi5uwgqcUgSA3UMw85bWZ-w4MHBRqqB971iZDCsuud_z7aV1sd1rOIkKBnFQCIjEQ';
        if (this.useTestInc) {
            companyId = 'r1MZtfWW7';
            approveToken = this.personalToken;
            silentToken = this.silentPublicToken;
        }
        await auth.authenticate({
            token: approve ? approveToken : silentToken,
            namespace: '/companies/' + companyId
        });
        log.s('authenticated with PUBLIC token');
    },

    async authenticateBearer(token) {
        let companyId = '';
        if (this.useTestInc) {
            companyId = 'r1MZtfWW7';
        }
        await auth.authenticate({
            token: token,
            namespace: '/companies/' + companyId
        });
        log.s('authenticated with BEARER token');
    },

    async authenticateCustom(companyId, token) {
        await auth.authenticate({
            token: token,
            namespace: '/companies/' + companyId
        });
        log.s('authenticated with CUSTOM token');
    },

    async createEnvelope(approve) {
        log.v(this.logTag + 'creating envelope using ' + (approve ? 'approval flow' : 'normal flow'));
        let envelope = {};
        let bearerToken;
        if (approve) {
            if (!this.fakeSubmit) {
                envelope = await envelopes.create('maxbo-fraktavtale-approve');
                bearerToken = await envelope.getBearerToken('/flows/only-editors-flow');
            }else {
                await new Promise(r => setTimeout(r, 1000));
            }
        }else {
            if (!this.fakeSubmit) {
                envelope = await envelopes.create('maxbo-fraktavtale-silent');
                bearerToken = await envelope.getBearerToken('/flows/no-recipients-flow-with-silent-parties');
            }else {
                await new Promise(r => setTimeout(r, 1000));
            }
        }
        if (!this.fakeSubmit) {
            auth.setToken(bearerToken);
            await envelope.reflect();
        }
        return envelope;
    },

    async setRecipient(envelope, action, recipient) {
        const role = {
            action: 'sign',
            label: 'Lagre',
            name: 'signer'
        };
        if (action == 'approve') {
            role.action = 'edit';
            role.label = 'Godkjenne';
            role.name = 'approver';
        }else if (action == 'editor') {
            role.action = 'edit';
            role.label = 'Endre';
            role.name = 'editor';
        }else if (action == 'associate') {
            role.action = 'edit';
            role.label = 'Bekrefte';
            role.name = 'associate';
        }else if (action == 'saver') {
            role.action = 'edit';
            role.label = 'Lagre';
            role.name = 'saver';
        }
        log.v(this.logTag + 'recipient detail set', recipient);
        log.v(this.logTag + 'recipient action set', role);
        if (!this.fakeSubmit) {
            await envelope.addRecipient({
                givenName: recipient.fname,
                familyName: recipient.lname,
                email: recipient.email,
                language: 'nb-NO',
                signingMethod: 'email',
                order: 1,
                role: role
            });
        }else {
            await new Promise(r => setTimeout(r, 500));
        }
    },

    getRecipient(person) {
        if (!person) {
            return {
                fname: 'Ukjent',
                lname: 'Person',
                email: 'magnus.ursin@verified.eu'
            }
        }
        let name = person.name.split(' ');
        let lname = name[name.length - 1];
        name.pop();
        return {
            fname: name.join(' '),
            lname: lname,
            email: person.email
        };
    },

    async setSilentParties(envelope, list) {
        // Add silent parties
        /*{
            givenName: 'Fraktavtale',
            familyName: this.ud.company.name,
            email: this.ud.contact_editor.email
        } */
        let metadata = {
            silentParties: list,
            language: 'nb_NO'
        };
        await envelope.put({ metadata: metadata });
    },

    async setFilename(envelope, filename) {
        log.v(this.logTag + 'set filename', filename);
        if (!this.fakeSubmit) {
            await envelope.firstDocument().put({ name: filename });
            await envelope.firstDocument().setTags(['fraktavtale']);
        }else {
            await new Promise(r => setTimeout(r, 500));
        }
    },

    async setUserdata(envelope, userdata) {
        log.v(this.logTag + 'set userdata', userdata);
        if (!this.fakeSubmit) {
            await envelope.firstTemplate().setUserData(userdata);
        }else {
            await new Promise(r => setTimeout(r, 500));
        }
    },

    async publish(envelope) {
        if (!this.fakeSubmit) {
            await envelope.publish();
        }else {
            await new Promise(r => setTimeout(r, 500));
        }
        log.s(this.logTag + 'envelope published');
    },

    async getEnvelope(documentUid) {
        let values = documentUid.split('/');
        let envelope = await envelopes.get(values[2]);
        await envelope.reflect();
        return envelope;
    },

    async getUserdata(envelope) {
        let userdata = await envelope.firstTemplate().getUserData();
        return userdata;
    },

    async getEnvelopeData(envelopeId) {
        let envelope = await envelopes.get(envelopeId);
        await envelope.reflect();
        let userdata = await envelope.firstTemplate().getUserData();
        return userdata;
    },

    async reflectEnvelope(envelope) {
        await envelope.reflect();
    },

    async queryEnvelopes() {
        
        //const descriptor = 'maxbo-fraktavtale-approve';
        //const descriptor = 'maxbo-discounts-approval';
        //const descriptor = 'maxbo-fraktavtale-silent';
        const descriptor = 'maxbo-discount-agreements';
        const skip = 100;

        const url = `/api/query-new/envelopes?filters={"and":[{"field":"documents.id","op":"exists","value":true},{"field":"trashed","op":"ne","value":true},{"field":"aborted","op":"ne","value":true},{"field":"descriptor.id","op":"eq","value":"${descriptor}"}]}&from=${skip}&limit=50&sort={"modified":-1}`;

        const config = {
            headers: {
                'Authorization': 'JWT ' + auth.token,
                'x-namespace': auth.namespace
            }
        }

        const response = await axios.get(url, config);
        //console.log('response', response);

        return response.data;

    },


    async getFullEnvelope(envelopeId) {
        const envelope = {
            id: envelopeId,
            contents: {},
            userdata: {}
        };
        
        const url = `/api/envelopes/${envelopeId}`;

        const config = {
            headers: {
                'Authorization': 'JWT ' + auth.token,
                'x-namespace': auth.namespace
            }
        }

        const response = await axios.get(url, config);
        //console.log('response', response);

        envelope.contents = response.data;
        envelope.userdata = response.data.documents[0].template.userData;

        return envelope;

    },

};
export default verified;